module.exports = __webpack_public_path__ + "img/欧博萨.png";